import { render, staticRenderFns } from "./WeightCircle.vue?vue&type=template&id=44964bb8"
import script from "./WeightCircle.vue?vue&type=script&lang=js"
export * from "./WeightCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports